import React from "react";
import "./About.css";

// Import all the components
import AboutHero from "../components/AboutHero.jsx";
import FounderSection from "../components/FounderSection.jsx";
import OurMission from "../components/OurMission.jsx";
import Vision from "../components/Vision.jsx";
import FAQ from "../components/FAQ.jsx";
import ContactUs from "../components/ContsctUs.jsx";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div className="about-page">
      <AboutHero />
      <FounderSection />
      <OurMission />
      <Vision />
      <FAQ />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default About;
